import {
  ChangeContext,
  NgxSliderModule,
  Options,
} from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { ProgressStepperComponent } from 'src/app/shared/components/progress-stepper/progress-stepper.component';
import { PropertyUploadNavigationComponent } from '../property-upload-navigation/property-upload-navigation.component';
import { PropertyUpload } from '../property-upload-wizard.component';
import { NumericOnlyDirective } from 'src/app/shared/directives/number-only.directive';

export interface StepThreeData {
  data: {
    minPriceValue: number | null;
    maxPriceValue: number | null;
  };
  nextStep: string;
}

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    ProgressStepperComponent,
    NgxSliderModule,
    FormsModule,
    PropertyUploadNavigationComponent,
    NumericOnlyDirective
  ],
})
export class StepThreeComponent implements OnInit {
  @Output() saveStepThree = new EventEmitter<StepThreeData>();
  @Output() previousButtonClicked = new EventEmitter<void>();

  @Input() Steps: string[] = [];
  @Input() PropertyData?: PropertyUpload;
  @Input() EncodedLocationBounds: string | undefined;
  @ViewChild('maxInput') maxInput!: ElementRef<HTMLInputElement>;

  minPrice: number = 20000;
  maxPrice: number | undefined = undefined;
  sliderValue: number = 0;
  sliderOptions: Options = {
    floor: 20000,
    ceil: 2000000,
    step: 1000,
  };

  minPriceValue: string | null = null;
  maxPriceValue: string | null = null;

  constructor() { }
  ngOnInit(): void {
    this.maxPrice = this.PropertyData?.MaxPrice ?? this.maxPrice;
    this.sliderValue = this.maxPrice ?? 0;
    this.maxPriceValue = this.maxPrice ? this.maxPrice.toLocaleString('de-DE') : null;
  }

  saveStep() {
    this.saveStepThree.emit({
      data: {
        minPriceValue: this.minPrice,
        maxPriceValue: this.maxPrice && (this.maxPrice > 0) ? this.maxPrice : null,
      },
      nextStep: 'Step4',
    });
  }

  public onPriceSliderChange(changeContext: ChangeContext) {
    this.MaxPriceChanged(changeContext.value.toString())
  }

  MaxPriceInput(price: string) {
    this.maxPriceValue = price;
    let realMaxPrice = Number(price);
    if (realMaxPrice > 2000000) {
      realMaxPrice = 2000000;
    }
    this.maxPriceValue = realMaxPrice.toString();
    this.maxPrice = realMaxPrice;
    this.sliderValue = realMaxPrice;
    return this.maxPriceValue
  }

  MaxPriceChanged(price: string) {
    let realMaxPrice = Number(this.MaxPriceInput(price));
    if (this.minPrice > realMaxPrice) {
      this.maxPriceValue = this.minPrice.toLocaleString('de-De')
      this.maxPrice = this.minPrice;
      return;
    }
    this.maxPriceValue = realMaxPrice.toLocaleString('de-DE');
    this.maxPrice = realMaxPrice;
  }
}
